import { render, staticRenderFns } from "./ProcessGroup.vue?vue&type=template&id=9faf3d82&"
import script from "./ProcessGroup.vue?vue&type=script&lang=js&"
export * from "./ProcessGroup.vue?vue&type=script&lang=js&"
import style0 from "./ProcessGroup.vue?vue&type=style&index=0&id=9faf3d82&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports